import { Button, SvgIcon, Tooltip, Typography } from '@mui/material';
import { Check as CheckIcon } from '@opengov/react-capital-assets';
import React from 'react';

import { DATA_TEST } from '../../enums';

import { useIsContentOverflowing } from '../../utils/hooks/useIsContentOverflowing';

interface IEntityOptionButtonProps {
  selected: boolean;
  name: string;
  dataTest: string;
  mobile?: boolean;
  handleClick(): void;
}

export const EntityOptionButton: React.FC<IEntityOptionButtonProps> = ({
  selected,
  name,
  dataTest,
  mobile,
  handleClick
}) => {
  const labelRef = React.useRef(null);
  const labelOverflowing = useIsContentOverflowing(labelRef, undefined, selected);

  return (
    <Tooltip title={labelOverflowing ? name : ''} enterNextDelay={500}>
      <Button
        variant="outlined"
        sx={{
          margin: 0.5,
          maxWidth: '31.5%',
          ...(mobile && {
            backgroundColor: selected ? 'action.selected' : 'action.hover',
            cursor: selected ? 'default' : 'pointer',
            height: 40,
            maxWidth: '100%',
            ':hover': {
              backgroundColor: !selected && 'action.hover',
              borderColor: !selected && 'text.primary'
            },
            ':hover .entity-selection': {
              color: !selected && 'text.primary'
            },
            svg: {
              fontSize: '1.5rem'
            }
          })
        }}
        color={selected ? 'primary' : 'secondary'}
        onClick={handleClick}
        data-test={dataTest}
      >
        {selected && (
          <SvgIcon
            inheritViewBox
            component={CheckIcon}
            sx={{ fontSize: '1.25rem', marginRight: 0.5 }}
            className={'entity-selection'}
            data-test={DATA_TEST.entity_selected_check_mark}
          />
        )}
        <Typography
          variant={mobile ? 'h3' : 'h5'}
          component="span"
          noWrap={true}
          ref={labelRef}
          className={'entity-selection'}
        >
          {name}
        </Typography>
      </Button>
    </Tooltip>
  );
};
